"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const walletItem_1 = require("./walletItem");
const BouncingLoaderComp = () => {
    return ((0, jsx_runtime_1.jsxs)(walletItem_1.BouncingLoader, { component: "div", children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div" }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div" }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div" })] }));
};
exports.default = BouncingLoaderComp;
